webpackJsonpAlexaSkill([3],{

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Contact_vue_vue_type_template_id_04b193a2___ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Contact_vue_vue_type_script_lang_js___ = __webpack_require__(441);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Contact_vue_vue_type_script_lang_js___) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Contact_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(97);





/* normalize component */

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Contact_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__Contact_vue_vue_type_template_id_04b193a2___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Contact_vue_vue_type_template_id_04b193a2___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ValidationHandler = __webpack_require__(405);

var _ValidationHandler2 = _interopRequireDefault(_ValidationHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorHandler = {
    mixins: [_ValidationHandler2.default],
    methods: {
        handleErrors: function handleErrors(error) {
            this.error.show = true;
            this.error.message = "Something went wrong. Please try again.";

            if (error.response.status === 422) {
                this.error.message = 'Please check the higlighted fields';
                this.getValidationErrors(error.response);
            } else if (error.response.status === 419) {
                this.error.message = 'Session Expired. Please refresh the page and try again';
            } else if (!!error.response.data.message) {
                this.error.message = error.response.data.message;
            }
        }
    },
    data: function data() {
        return {
            error: {
                show: false,
                header: '',
                message: ''
            }
        };
    }
};

exports.default = ErrorHandler;

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ValidationHandler = {
    methods: {
        initValidator: function initValidator(fields) {
            var _this = this;

            fields.forEach(function (field) {
                _this.$set(_this.errors, field, { message: [] });
            });
        },
        clearErrors: function clearErrors() {
            var _this2 = this;

            Object.keys(this.errors).forEach(function (item) {
                _this2.errors[item].message = [];
            });
        },
        getValidationErrors: function getValidationErrors(response) {
            var _this3 = this;

            var message = '';
            // Loop through each error message and add it to our message variable
            Object.keys(response.data.errors).forEach(function (item) {
                var field = response.data.errors[item];
                for (var i = 0; i < field.length; i++) {
                    if (!!_this3.errors[item]) {
                        _this3.errors[item].message = response.data.errors[item];
                    }
                }
            });
        }
    },
    data: function data() {
        return {
            errors: {}
        };
    }
};

exports.default = ValidationHandler;

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Bus = __webpack_require__(148);

var _Bus2 = _interopRequireDefault(_Bus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loading = {
    watch: {
        loading: function loading(value) {
            _Bus2.default.$emit('loading', value);
        }
    },
    data: function data() {
        return {
            loading: false
        };
    }
};

exports.default = Loading;

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _Loading = __webpack_require__(406);

var _Loading2 = _interopRequireDefault(_Loading);

var _ErrorHandler = __webpack_require__(404);

var _ErrorHandler2 = _interopRequireDefault(_ErrorHandler);

var _vueRecaptcha = __webpack_require__(505);

var _vueRecaptcha2 = _interopRequireDefault(_vueRecaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'Contact',
	mixins: [_Loading2.default, _ErrorHandler2.default],
	components: {
		VueRecaptcha: _vueRecaptcha2.default
	},
	created: function created() {
		this.initValidator(['name', 'email', 'subject', 'message']);
		this.name = this.$store.state.user.name;
		this.email = this.$store.state.user.email;
	},

	methods: {
		sendMessage: function sendMessage() {
			var _this = this;

			this.submitting = true;
			this.clearErrors();
			this.error.show = false;
			this.success = false;
			axios.post('/api/message', {
				name: this.name,
				email: this.email,
				subject: this.subject,
				message: this.message,
				verify: this.verifyResponse
			}).then(function (response) {
				_this.submitting = false;
				_this.success = true;
			}).catch(function (error) {
				_this.handleErrors(error);
				_this.submitting = false;
				_this.$refs.recaptcha.reset();
			});
		},
		setError: function setError(message) {
			this.error.show = true;
			this.error.message = message;
		},
		verify: function verify(response) {
			this.verifyResponse = response;
		}
	},
	computed: {
		disable: function disable() {
			return this.loading || this.submitting;
		}
	},
	data: function data() {
		return {
			submitting: false,
			verifyResponse: '',
			success: false,
			name: '',
			email: '',
			subject: '',
			message: ''
		};
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 441:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Contact_vue_vue_type_script_lang_js___ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Contact_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Contact_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Contact_vue_vue_type_script_lang_js___) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Contact_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Contact_vue_vue_type_script_lang_js____default.a); 

/***/ }),

/***/ 472:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Contact_vue_vue_type_template_id_04b193a2___ = __webpack_require__(494);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Contact_vue_vue_type_template_id_04b193a2___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Contact_vue_vue_type_template_id_04b193a2___["b"]; });


/***/ }),

/***/ 494:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-3",attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","lg8":"","offset-lg2":""}},[_c('v-alert',{attrs:{"color":"error","icon":"warning","transition":"scale-transition"},model:{value:(_vm.error.show),callback:function ($$v) {_vm.$set(_vm.error, "show", $$v)},expression:"error.show"}},[_vm._v("\n\t\t\t      "+_vm._s(_vm.error.message)+"\n\t\t\t    ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","lg10":"","offset-lg1":""}},[_c('v-alert',{attrs:{"color":"success","icon":"check_circle","transition":"scale-transition"},model:{value:(_vm.success),callback:function ($$v) {_vm.success=$$v},expression:"success"}},[_vm._v("\n\t\t      Message sent! \n\t\t    ")])],1),_vm._v(" "),_c('v-flex',{staticClass:"mt-2",attrs:{"xs12":"","lg8":"","offset-lg2":""}},[_c('v-card',{attrs:{"light":"","color":"white"},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.sendMessage($event)}}},[_c('v-card-title',{staticClass:"title primary white--text"},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mail")]),_vm._v(" Contact")],1),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"name":"name","label":"Name","id":"name","disabled":_vm.disable,"error-messages":_vm.errors.name.message,"required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"email","label":"Email","id":"email","disabled":_vm.disable,"error-messages":_vm.errors.email.message,"required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"subject","label":"subject","id":"subject","disabled":_vm.disable,"error-messages":_vm.errors.subject.message,"required":""},model:{value:(_vm.subject),callback:function ($$v) {_vm.subject=$$v},expression:"subject"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"message","label":"Message","id":"message","disabled":_vm.disable,"error-messages":_vm.errors.message.message,"required":"","multi-line":""},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}}),_vm._v(" "),_c('vue-recaptcha',{ref:"recaptcha",attrs:{"sitekey":"6LfB8y8UAAAAAOc_QbTHyEiNFi092OTJr0msSD_u"},on:{"expired":function($event){return _vm.setError('reCapthca Expired')},"verify":_vm.verify}}),_vm._v(" "),_c('v-divider',{staticClass:"mt-4 mb-2"}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","loading":_vm.submitting,"disabled":_vm.disable},on:{"click":function($event){return _vm.sendMessage()}}},[_vm._v("Send Message")])],1)],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var defer = function defer() {
  var state = false; // Resolved or not

  var callbacks = [];

  var resolve = function resolve(val) {
    if (state) {
      return;
    }

    state = true;

    for (var i = 0, len = callbacks.length; i < len; i++) {
      callbacks[i](val);
    }
  };

  var then = function then(cb) {
    if (!state) {
      callbacks.push(cb);
      return;
    }

    cb();
  };

  var deferred = {
    resolved: function resolved() {
      return state;
    },
    resolve: resolve,
    promise: {
      then: then
    }
  };
  return deferred;
};

var ownProp = Object.prototype.hasOwnProperty;
function createRecaptcha() {
  var deferred = defer();
  return {
    notify: function notify() {
      deferred.resolve();
    },
    wait: function wait() {
      return deferred.promise;
    },
    render: function render(ele, options, cb) {
      this.wait().then(function () {
        cb(window.grecaptcha.render(ele, options));
      });
    },
    reset: function reset(widgetId) {
      if (typeof widgetId === 'undefined') {
        return;
      }

      this.assertLoaded();
      this.wait().then(function () {
        return window.grecaptcha.reset(widgetId);
      });
    },
    execute: function execute(widgetId) {
      if (typeof widgetId === 'undefined') {
        return;
      }

      this.assertLoaded();
      this.wait().then(function () {
        return window.grecaptcha.execute(widgetId);
      });
    },
    checkRecaptchaLoad: function checkRecaptchaLoad() {
      if (ownProp.call(window, 'grecaptcha') && ownProp.call(window.grecaptcha, 'render')) {
        this.notify();
      }
    },
    assertLoaded: function assertLoaded() {
      if (!deferred.resolved()) {
        throw new Error('ReCAPTCHA has not been loaded');
      }
    }
  };
}
var recaptcha = createRecaptcha();

if (typeof window !== 'undefined') {
  window.vueRecaptchaApiLoaded = recaptcha.notify;
}

var VueRecaptcha = {
  name: 'VueRecaptcha',
  props: {
    sitekey: {
      type: String,
      required: true
    },
    theme: {
      type: String
    },
    badge: {
      type: String
    },
    type: {
      type: String
    },
    size: {
      type: String
    },
    tabindex: {
      type: String
    },
    loadRecaptchaScript: {
      type: Boolean,
      "default": false
    },
    recaptchaScriptId: {
      type: String,
      "default": '__RECAPTCHA_SCRIPT'
    },
    recaptchaHost: {
      type: String,
      "default": 'www.google.com'
    },
    language: {
      type: String,
      "default": ''
    }
  },
  beforeMount: function beforeMount() {
    if (this.loadRecaptchaScript) {
      if (!document.getElementById(this.recaptchaScriptId)) {
        // Note: vueRecaptchaApiLoaded load callback name is per the latest documentation
        var script = document.createElement('script');
        script.id = this.recaptchaScriptId;
        script.src = "https://" + this.recaptchaHost + "/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=" + this.language;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    recaptcha.checkRecaptchaLoad();

    var opts = _extends({}, this.$props, {
      callback: this.emitVerify,
      'expired-callback': this.emitExpired,
      'error-callback': this.emitError
    });

    var container = this.$slots["default"] ? this.$el.children[0] : this.$el;
    recaptcha.render(container, opts, function (id) {
      _this.$widgetId = id;

      _this.$emit('render', id);
    });
  },
  methods: {
    reset: function reset() {
      recaptcha.reset(this.$widgetId);
    },
    execute: function execute() {
      recaptcha.execute(this.$widgetId);
    },
    emitVerify: function emitVerify(response) {
      this.$emit('verify', response);
    },
    emitExpired: function emitExpired() {
      this.$emit('expired');
    },
    emitError: function emitError() {
      this.$emit('error');
    }
  },
  render: function render(h) {
    return h('div', {}, this.$slots["default"]);
  }
};

/* harmony default export */ __webpack_exports__["default"] = (VueRecaptcha);


/***/ })

});


// WEBPACK FOOTER //
// 3.app.min.js